const question5 = {
    'question': 'Ile powinna trwać interwencja kryzysowa?',
    'answer': 'Długość interwencji kryzysowej zależy od indywidualnych potrzeb osoby lub rodziny w kryzysie. Zazwyczaj trwa ona od kilku spotkań do kilku miesięcy.',
}

export default question5;